export default "__VITE_ASSET__CcJcQMSY__"